import { HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConnectorGlobalErrorHandlerService, GlobalRequestErrorHandlerFunction, MaintenanceService } from '@libs/shared/common';
import { catchError, defer, retry, tap, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShopRequestErrorHandlerService {
  private readonly maintenanceService: MaintenanceService = inject(MaintenanceService);
  private readonly errorHandler: ConnectorGlobalErrorHandlerService = inject(ConnectorGlobalErrorHandlerService);

  public init(): void {
    this.errorHandler.registerGlobalErrorHandler(425, 'shop', this.createTooEarlyRequestErrorHandler());
    this.errorHandler.registerGlobalErrorHandler(HttpStatusCode.ServiceUnavailable, 'shop', this.createServiceNotAvailableRequestErrorHandler());
  }

  private createTooEarlyRequestErrorHandler(): GlobalRequestErrorHandlerFunction<unknown> {
    return (_response, _service, _endpoint, originalRequest) => {
      return defer(() => {
        this.maintenanceService.setMaintenanceMode(true, 'tooEarly');

        return originalRequest.pipe(
          retry({
            count: 60,
            delay: 5000,
          }),
          tap(() => {
            this.maintenanceService.setMaintenanceMode(false, 'tooEarly');
          }),
          catchError((err: unknown) => {
            this.maintenanceService.setMaintenanceMode(true, 'error');

            return throwError(() => err);
          }),
        );
      });
    };
  }

  private createServiceNotAvailableRequestErrorHandler(): GlobalRequestErrorHandlerFunction<unknown> {
    return (_response, _service, _endpoint, originalRequest) => {
      return defer(() => {
        this.maintenanceService.setMaintenanceMode(true);

        return originalRequest.pipe(
          retry({
            // max 30min
            count: 180,
            delay: 10000,
          }),
          tap(() => {
            this.maintenanceService.setMaintenanceMode(false);
          }),
          catchError((err: unknown) => {
            this.maintenanceService.setMaintenanceMode(true, 'error');

            return throwError(() => err);
          }),
        );
      });
    };
  }
}
